var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.availableLocales),function(locale){return _c('Button',{key:locale,staticClass:"ml-2",class:{
      'bg-brand': (locale == _vm.currentLocale),
      'bg-transparent text-brand': !(locale == _vm.currentLocale),
    },domProps:{"textContent":_vm._s(locale)},on:{"click":function($event){return _vm.setLocale(locale)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }